<script setup lang="ts">
import {getYouTubeThumbnail} from "~/utils/scripts/youtube";
import PlayerAwaitingLoad from "~/components/PlayerAwaitingLoad.vue";

const {videoId} = defineProps<{
  videoId: string;
}>();

const imageMaxRes = getYouTubeThumbnail(videoId, "maxresdefault");
const imageFallback = getYouTubeThumbnail(videoId, "hqdefault");
const playersVars = {
  rel: 0
} as YT.PlayerVars;
</script>

<template>
  <ScriptYouTubePlayer
    :video-id="videoId"
    :player-vars="playersVars"
    class="col-span-full !w-auto !aspect-video overflow-hidden">
    <template #placeholder>
      <img
        class="w-full grayscale"
        loading="lazy"
        :src="imageMaxRes"
        :data-fallback-src="imageFallback"
        onload="if (this.naturalWidth == 120 && this.naturalHeight == 90) { (this.src = this.dataset.fallbackSrc) }"
        alt="" />
    </template>
    <template #awaitingLoad>
      <PlayerAwaitingLoad></PlayerAwaitingLoad>
    </template>
  </ScriptYouTubePlayer>
</template>

<style scoped lang="scss"></style>
